export interface BillingReceiptItem {
  name: string;
  imageUrl?: string;
  quantity: number;
  unit?: string;
  mrp?: number;
  sellingPrice?: number;
  discountAmount?: number;
  lineTotal: number;
}

export interface BillingOrderDetailsData {
  invoiceNumber: string;
  orderNumber?: string;
  invoiceDate?: string;
  customer?: { name?: string; maskedMobile?: string };
  store?: { name?: string; address?: string };
  legal?: { cin?: string; gstin?: string; fssaiLicenseNumber?: string };
  payment?: { mode?: string; status?: string; displayText?: string };
  summary: {
    itemCount: number;
    totalUnits: number;
    taxableAmount: number;
    discountAmount: number;
    couponDiscountAmount: number;
    rewardPointDiscountAmount: number;
    deliveryCharge: number;
    taxAmount: number;
    paymentGatewayCharges: number;
    grossAmount: number;
    rewardPointsEarned: number;
  };
  items: BillingReceiptItem[];
}

export interface OrderReceiptData {
  receiptType: "order";
  orderNumber: string;
  orderDate?: string;
  customer?: { name?: string; maskedMobile?: string };
  store?: { name?: string; address?: string };
  payment?: { mode?: string; status?: string; displayText?: string };
  summary: BillingOrderDetailsData["summary"] & { totalAmountPaid: number };
  items: BillingReceiptItem[];
}

export type BillingReceiptErrorReason = "not-found" | "expired" | "error";

export class BillingReceiptError extends Error {
  constructor(public readonly reason: BillingReceiptErrorReason) {
    super(reason);
    this.name = "BillingReceiptError";
  }
}
